// @flow

import React from 'react';
import styled, { css } from 'styled-components';

import appleStoreDE from '../../../assets/images/badge/apple-store-de.svg';
import appleStoreEN from '../../../assets/images/badge/apple-store-en.svg';
import appleStoreES from '../../../assets/images/badge/apple-store-es.svg';
import appleStoreFR from '../../../assets/images/badge/apple-store-fr.svg';
import appleStoreIT from '../../../assets/images/badge/apple-store-it.svg';
import appleStorePT from '../../../assets/images/badge/apple-store-pt.svg';
import googlePlayDE from '../../../assets/images/badge/google-play-de.png';
import googlePlayEN from '../../../assets/images/badge/google-play-en.png';
import googlePlayES from '../../../assets/images/badge/google-play-es.png';
import googlePlayFR from '../../../assets/images/badge/google-play-fr.png';
import googlePlayIT from '../../../assets/images/badge/google-play-it.png';
import googlePlayPT from '../../../assets/images/badge/google-play-pt.png';

type StoreBadgeProps = {
  className?: string,
  name: string,
};

const getResource = (name: string) => {
  switch (name) {
    case 'apple-store-de':
      return appleStoreDE;
    case 'apple-store-en':
      return appleStoreEN;
    case 'apple-store-es':
      return appleStoreES;
    case 'apple-store-fr':
      return appleStoreFR;
    case 'apple-store-it':
      return appleStoreIT;
    case 'apple-store-pt':
      return appleStorePT;
    case 'google-play-de':
      return googlePlayDE;
    case 'google-play-en':
      return googlePlayEN;
    case 'google-play-es':
      return googlePlayES;
    case 'google-play-fr':
      return googlePlayFR;
    case 'google-play-it':
      return googlePlayIT;
    case 'google-play-pt':
      return googlePlayPT;
    default:
      if (name.startsWith('apple-store')) return appleStoreFR;
      else if (name.startsWith('google-play')) return googlePlayFR;
      return null;
  }
};

const Container = styled.div`
  height: 60px;
`;

const Badge = styled.img`
  box-sizing: border-box;
  height: 100%;

  ${({ $apple }) =>
    $apple
    && css`
      padding: 6%;
      width: 140px;
    `};
`;

export const StoreBadge = ({ className, name }: StoreBadgeProps) => {
  const resource = getResource(name);

  if (!resource) {
    return null;
  }

  return (
    <>
      <Container>
        <Badge
          src={resource}
          className={className}
          $apple={name.startsWith('apple-store')}
        />
      </Container>
    </>
  );
};
